import { Flex, ScrollArea, Stack } from '@mantine/core';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setRelatedTasksMode } from '../../../../../store/strategy-store/strategy-store.actions';
import { Divider } from '../../../../../ui-library/divider/divider';
import { Select } from '../../../../../ui-library/select/select';
import { SmallSquareButton } from '../../../../financials/charts/shared/small-square-button';
import { RelatedTasksMode } from '../related-tasks-tab.type';
import { FiltersList } from './filters-list';
import { getRelatedTasksModeOptions } from './filters.helpers';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const mode = useRelatedTasksTabStore((state) => state.mode);

  const handleModeChange = (value: string) => {
    setRelatedTasksMode(value as RelatedTasksMode);
  };

  return (
    <Stack gap="md" h="100%">
      <Flex justify="space-between" align="center" w="100%">
        <Select size="sm" options={getRelatedTasksModeOptions()} value={mode} onChange={handleModeChange} />
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" style={{ flexShrink: 0 }} />
      </Flex>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <FiltersList />
      </ScrollArea>
    </Stack>
  );
};
